export const ASSETS_PUBLIC_PATH = process.env
  .NEXT_PUBLIC_ASSETS_PUBLIC_PATH as string

export function getAssetURL(src: string, quality?: number): string {
  if (!src) return ''

  const isSvg = src.toLowerCase().endsWith('.svg')
  if (isSvg) return src

  const isCms = src.includes('/ton-cms')

  if (isCms) {
    const sanitizedSrc = src.replace(/\.(png|jpe?g|webp)$/i, '')
    const extension = quality !== undefined ? `.q${quality}.webp` : `.webp`
    return `${sanitizedSrc}${extension}`
  }

  return `${ASSETS_PUBLIC_PATH}/${src}`
}
